import { MaterialBalanceByFactory, MaterialBalanceByFactoryRequest } from 'bus/factory/types';

import { omdApi } from '../api';
import { MaterialBalance } from './types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    createMaterialBalance: builder.mutation<void, MaterialBalance>({
      query: (data) => ({
        url: '/v1/MaterialBalance/InBalance',
        method: 'POST',
        body: data,
      }),
    }),
    getMaterialBalanceByFactory: builder.query<MaterialBalanceByFactory, MaterialBalanceByFactoryRequest>({
      query: (data) => ({
        url: `/v1/MaterialBalance/${data.id}`,
        params: data,
      }),
    }),
  }),
});

export const {
  useCreateMaterialBalanceMutation,
  useGetMaterialBalanceByFactoryQuery,
  useLazyGetMaterialBalanceByFactoryQuery,
} = request;
